import './workingDetailsCard.scss';
import employeeImage from '../../../assets/icons/employee.png';
import repeatImage from '../../../assets/icons/repeat.png';

interface IWorkingDetailsCard {
    weeks: string;
    days: string;
    time: string;
    breakHours: string;
    hours: string;
}
const WorkingDetailsCard = ({ weeks, days, time, hours, breakHours }: IWorkingDetailsCard) => {
    return (
        <div className="workingDetailsDrawerCard">
            <div className="container">
                <div className="employeeImageWrapper">
                    <img src={employeeImage} alt="" className="employeeImage" />
                </div>

                <div className="timeContainer">
                    <div className="rowOne">
                        <div className="repeatImage">
                            <img src={repeatImage} alt="" className="employeeImage" />
                        </div>

                        <div className="weekCount">{weeks}</div>
                        <div className="divider" />
                        <div className="days">{days}</div>
                    </div>

                    <div className="rowTwo">
                        <div className="time">{time}</div>
                        <div className="break">({breakHours})</div>
                    </div>
                </div>

                <div className="hoursContainer">
                    <div className="hoursText">{hours}</div>
                </div>
            </div>
        </div>
    );
};

export default WorkingDetailsCard;
